import React from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
export function TermsPage() {
  return <div className="min-h-screen" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1972">
      <Navigation data-id="element-1973" />

      <div className="pt-32 pb-20 px-4" data-id="element-1974">
        <div className="max-w-4xl mx-auto" data-id="element-1975">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1976">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{
            color: 'var(--text-primary)'
          }} data-id="element-1977">
              Terms of{' '}
              <span style={{
              color: 'var(--accent)'
            }} data-id="element-1978">
                Service
              </span>
            </h1>
            <p className="text-sm mb-8" style={{
            color: 'var(--text-muted)'
          }} data-id="element-1979">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
            </p>

            <div className="space-y-8" data-id="element-1980">
              <Section title="1. Agreement to Terms" data-id="element-1981">
                <p data-id="element-1982">
                  By accessing or using Jetly Agency's services, you agree to be
                  bound by these Terms of Service. If you disagree with any part
                  of these terms, you may not use our services.
                </p>
              </Section>

              <Section title="2. Services Description" data-id="element-1983">
                <p data-id="element-1984">
                  Jetly Agency provides professional web design and development
                  services, including:
                </p>
                <ul data-id="element-1985">
                  <li data-id="element-1986">Free website demo creation</li>
                  <li data-id="element-1987">Custom website design and development</li>
                  <li data-id="element-1988">Website hosting setup assistance</li>
                  <li data-id="element-1989">30 days of post-launch support</li>
                </ul>
              </Section>

              <Section title="3. Pricing and Payment" data-id="element-1990">
                <p data-id="element-1991">
                  <strong data-id="element-1992">Free Demo:</strong> We provide a free website demo
                  with no obligation. You only pay if you approve the design and
                  want to launch.
                </p>
                <p data-id="element-1993">
                  <strong data-id="element-1994">Professional Package ($249):</strong> One-time payment
                  for complete website. Payment required after demo approval
                  before final launch.
                </p>
                <p data-id="element-1995">
                  <strong data-id="element-1996">Hosting (€10/month):</strong> Optional hosting and
                  maintenance service.
                </p>
                <p data-id="element-1997">
                  All prices are in Euros (EUR). Payments are non-refundable
                  once work has commenced.
                </p>
              </Section>

              <Section title="4. Project Timeline" data-id="element-1998">
                <p data-id="element-1999">
                  Standard projects are completed within 24 hours from demo
                  approval. Timeline may vary based on:
                </p>
                <ul data-id="element-2000">
                  <li data-id="element-2001">Project complexity</li>
                  <li data-id="element-2002">Client feedback response time</li>
                  <li data-id="element-2003">Content availability</li>
                </ul>
              </Section>

              <Section title="5. Revisions and Changes" data-id="element-2004">
                <p data-id="element-2005">
                  Our package includes 3 rounds of revisions. Additional
                  revisions may incur extra charges. Major scope changes after
                  approval may require additional fees.
                </p>
              </Section>

              <Section title="6. Intellectual Property" data-id="element-2006">
                <p data-id="element-2007">
                  Upon full payment, you own all rights to the final website
                  design and code. Before payment, all work remains property of
                  Jetly Agency.
                </p>
              </Section>

              <Section title="7. Client Responsibilities" data-id="element-2008">
                <p data-id="element-2009">Clients are responsible for:</p>
                <ul data-id="element-2010">
                  <li data-id="element-2011">Providing accurate content and materials</li>
                  <li data-id="element-2012">Timely feedback and approvals</li>
                  <li data-id="element-2013">
                    Domain registration and hosting (if not using our services)
                  </li>
                  <li data-id="element-2014">Compliance with applicable laws</li>
                </ul>
              </Section>

              <Section title="8. Limitation of Liability" data-id="element-2015">
                <p data-id="element-2016">
                  Jetly Agency is not liable for indirect, incidental, or
                  consequential damages arising from use of our services. Our
                  total liability is limited to the amount paid for services.
                </p>
              </Section>

              <Section title="9. Termination" data-id="element-2017">
                <p data-id="element-2018">
                  Either party may terminate the agreement with written notice.
                  Payments for completed work are non-refundable.
                </p>
              </Section>

              <Section title="10. Contact" data-id="element-2019">
                <p data-id="element-2020">For questions about these Terms, contact us at:</p>
                <p data-id="element-2021">
                  Email: legal@jetly.agency
                  <br data-id="element-2022" />
                  Telegram: @jetlyagency
                </p>
              </Section>
            </div>
          </motion.div>
        </div>
      </div>

      <Footer data-id="element-2023" />
      <CookieBanner data-id="element-2024" />
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="rounded-2xl border p-6 sm:p-8" style={{
    borderColor: 'var(--border)',
    backgroundColor: 'var(--bg-secondary)'
  }} data-id="element-2025">
      <h2 className="text-xl sm:text-2xl font-bold mb-4" style={{
      color: 'var(--text-primary)'
    }} data-id="element-2026">
        {title}
      </h2>
      <div className="space-y-3 text-sm sm:text-base [&>ul]:list-disc [&>ul]:ml-6 [&>ul]:space-y-2" style={{
      color: 'var(--text-secondary)'
    }} data-id="element-2027">
        {children}
      </div>
    </div>;
}